import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export const getAllNotifications = async (
  xTeamId: string,
  page: number = 1,
  per_page: number = 25
): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !xTeamId) {
    return;
  }

  try {
    const response = await axios.get(
      `${API_URL}/v1/notifications?page=${page}&per_page=${per_page}`
    );
    return response;
  } catch (error) {}
};

export const useGetAllNotifications = (
  xTeamId: string,
  page: number,
  per_page: number,
  config = {}
) => {
  const { addNotification } = useNotificationStore();
  return useQuery<any, Error>({
    queryKey: ['notifications', page, per_page],
    queryFn: () => getAllNotifications(xTeamId, page, per_page),
    onError: (error) => {
      addNotification({
        type: 'error',
        title: 'Failed to get notifications',
        message: "We couldn't fetch the notifications. Please try again.",
      });
    },
    ...config,
  });
};
